import React from 'react';
import MarkerGauge from '@splunk/dashboard-visualizations/MarkerGauge';

export default () => (
    <MarkerGauge
        options={{ majorUnit: '25' }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'count' }],
                    columns: [['78']],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
